<div class="checkout-overlay" *ngIf="show" (click)="close.emit()">

  <div class="checkout-modal" (click)="$event.stopPropagation()">

    <!-- HEADER -->
    <div class="checkout-header">

      <div class="header-text">
        <h3>Checkout</h3>
        <p>Almost there! Confirm your details to place the order.</p>
      </div>

      <button type="button" class="close-icon-btn" (click)="close.emit()">
        <i class="fa fa-times"></i>
      </button>

    </div>

    <div class="checkout-body">

      <form [formGroup]="form">

        <!-- STEP 1: CONTACT DETAILS -->
        <div class="checkout-section">

          <div class="section-heading">
            <span class="step-badge">1</span>
            <h4>Contact Details</h4>
          </div>

          <div class="field-grid">

            <div class="field-group">
              <label>Full Name</label>
              <input
                formControlName="name"
                placeholder="Enter your name">
            </div>

            <div class="field-group">
              <label>Mobile Number</label>
              <input
                formControlName="mobile"
                placeholder="10-digit mobile number">
            </div>

            <div class="field-group full-width">
              <label>Email Address</label>
              <input
                formControlName="email"
                placeholder="Enter your email">
            </div>

          </div>

          <div class="password-field field-group full-width" *ngIf="showPassword">

            <label>
              {{ customerExists ? 'Password' : 'Set Password (Optional)' }}
            </label>

            <input
              type="password"
              formControlName="password"
              [placeholder]="customerExists
              ? 'Enter Password'
              : 'Create a password to save your details'">

          </div>

        </div>

        <!-- STEP 2: DELIVERY ADDRESS -->
        <div class="checkout-section" *ngIf="addresses.length">

          <div class="section-heading">
            <span class="step-badge">2</span>
            <h4>Delivery Address</h4>
          </div>

          <div class="address-list">

            <label
              class="address-card"
              *ngFor="let address of addresses"
              [class.selected]="selectedAddressId === address.id">

              <input
                class="address-radio"
                type="radio"
                name="selectedAddress"
                [value]="address.id"
                [(ngModel)]="selectedAddressId"
                [ngModelOptions]="{standalone:true}">

              <div class="radio-dot"></div>

              <div class="address-content">

                <div class="address-header">

                  <span class="address-type">
                    <i class="fa fa-map-marker-alt"></i>
                    {{address.address_type}}
                  </span>

                  <span
                    class="default-badge"
                    *ngIf="address.is_default">
                    Default
                  </span>

                </div>

                <div class="address-line">
                  {{
                    address.address_line1.length > 35
                    ? (address.address_line1 | slice:0:35) + '...'
                    : address.address_line1
                  }}
                </div>

                <div class="city-line">
                  {{address.city}}, {{address.state}}
                </div>

              </div>

            </label>

          </div>

        </div>

        <!-- STEP 3: ORDER SUMMARY -->
        <div class="checkout-section" *ngIf="orderData?.items?.length">

          <div class="section-heading">
            <span class="step-badge">3</span>
            <h4>Order Summary</h4>
          </div>

          <div class="order-summary-card">

            <div class="order-item" *ngFor="let item of orderData.items">

              <div class="order-item-info">
                <span class="order-item-name">
                  {{ item.title || item.product_name || item.name }}
                </span>
                <span class="order-item-qty" *ngIf="item.quantity">
                  Qty: {{ item.quantity }}
                </span>
              </div>

              <span class="order-item-price">
                ₹{{ item.price || item.product_cost }}
              </span>

            </div>

            <div class="order-total-row">
              <span>Total Amount</span>
              <span class="order-total-amount">₹{{ orderData.total }}</span>
            </div>

          </div>

        </div>

      </form>

    </div>

    <!-- STICKY FOOTER / CTA -->
    <div class="checkout-footer">

      <div class="footer-total">
        <span class="footer-total-label">Total Payable</span>
        <span class="footer-total-amount">₹{{ orderData?.total }}</span>
      </div>

      <button
        type="button"
        (click)="confirmOrder()"
        [disabled]="isProcessing"
        class="confirm-btn">

        <span *ngIf="!isProcessing">
          <i class="fa fa-lock"></i>
          Confirm &amp; Pay
        </span>

        <span *ngIf="isProcessing">
          <i class="fa fa-spinner fa-spin"></i>
          Processing...
        </span>

      </button>

      <p class="secure-note">
        <i class="fa fa-shield-alt"></i>
        100% secure payment powered by Razorpay
      </p>

    </div>

  </div>

</div>